import { BoxProps, Flex, Box } from '@chakra-ui/layout';
import Head from 'next/head';

import { PageHeader } from './PageHeader';

import { getConfig } from '@/shared/getEnv';

interface PageProps extends BoxProps {
  withHeader?: boolean;
  canonical?: string;
}

const { publicRuntimeConfig: config } = getConfig();

function makeCanonical(pathname: string) {
  return config.origin + config.basePath + pathname;
}

function Page({ withHeader = true, children, canonical, ...props }: PageProps) {
  return (
    <Flex direction="column" minHeight="100vh">
      <Head>
        <meta name="robots" content="noindex, nofollow" />
        {canonical && <link key="canonical" rel="canonical" href={canonical} />}
      </Head>
      {withHeader && <PageHeader />}
      <Box
        bgColor="gray.25"
        flex="1"
        px={{ base: '1rem', md: '3rem' }}
        py="2rem"
        {...props}
      >
        {children}
      </Box>
    </Flex>
  );
}

export type { PageProps };
export { Page, makeCanonical };
